import { createContext, use } from 'react';

import type {
  ErrorCorrectionLevel,
  InnerEyeStyle,
  ModuleStyle,
  OuterEyeStyle,
  QrDesign,
} from '../domain/types';

export interface QrActions {
  setContent: (content: string) => void;
  setErrorCorrectionLevel: (level: ErrorCorrectionLevel) => void;
  setSize: (size: number) => void;
  setModuleStyle: (style: ModuleStyle) => void;
  setModuleColor: (color: string) => void;
  setBackgroundColor: (color: string) => void;
  setOuterEyeStyle: (style: OuterEyeStyle) => void;
  setInnerEyeStyle: (style: InnerEyeStyle) => void;
  setEyeColor: (color: string) => void;
  setOuterBorderRadius: (radius: number) => void;
  setInnerBorderRadius: (radius: number) => void;
  setStyleEyesAsModules: (enabled: boolean) => void;
  setCenterImage: (file: File | null) => void;
  setCenterImageSize: (size: number) => void;
  setCustomModuleImage: (file: File | null) => void;
  reset: () => void;
  undo: () => void;
  redo: () => void;
}

export interface QrContextValue {
  readonly design: QrDesign;
  readonly actions: QrActions;
  readonly canUndo: boolean;
  readonly canRedo: boolean;
}

export const QrContext = createContext<QrContextValue | null>(null);

export function useQrContext(): QrContextValue {
  const value = use(QrContext);
  if (value === null) {
    throw new Error('useQrContext muss innerhalb von <QrProvider> verwendet werden.');
  }
  return value;
}
